import React, { useState } from 'react';
import { styled } from '../../../../shared/Theme/theme';
import { Form, Formik } from 'formik';
import { localizationSelectors } from '../../../../../state/ducks/localization/selectors';
import { RootState } from '../../../../../state/store/store';
import { connect } from 'react-redux';
import Button from '../../../../shared/SmallComponents/Button';
import { ModalFooter, ModalFormContainer } from '../../../../shared/Modal/Modal';
import Loader from '../../../../shared/SmallComponents/Loader';
import { link } from '../../../../../models/entities/product/link';
import { FormTextInput } from '../../../../shared/inputs/form';
import FieldLabel from '../../../../shared/SmallComponents/FieldLabel';

export enum formMode {
    NEW,
    EDIT
}

interface formFields {
    title?: string;
    url?: string;
}
type Props = {
    link?: link;
    mode: formMode;
    localizations?: any;
    openedFromModal?: {
        setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    };
    createProductLink: (productId: string, link: link) => Promise<boolean>;
    updateProductLink: (productId: string, link: link) => Promise<boolean>;
    productId: string;
};

const LinkFormConnected = ({ productId, link, localizations, mode, openedFromModal, createProductLink, updateProductLink }: Props) => {
    const [submitLoading, setLoading] = useState(false);
    let initFormValues: formFields = {
        title: '',
        url: ''
    };
    const setInitialValues = () => {
        if (!link || mode === formMode.NEW) {
            return initFormValues;
        } else {
            initFormValues.title = link.title;
            initFormValues.url = link.url;
            return initFormValues;
        }
    };
    const validate = (values: any) => {
        const errors: any = {};
        if (!values.title) errors.title = localizations.links.form.required_error;

        const maxLengthValidation = (field: string, maxLength: number, message: string) => {
            if (values[field] && values[field].length > maxLength) {
                errors[field] = message;
            }
        };

        maxLengthValidation('title', 100, localizations.links.form.title_max_length_error);
        maxLengthValidation('url', 250, localizations.links.form.url_max_length_error);
        return errors;
    };
    const submit = (values: any) => {
        const payload: link = {
            title: values.title,
            url: values.url
        } as link;
        setLoading(true);
        if (mode === formMode.NEW)
            createProductLink(productId, payload)
                .then((value) => {
                    if (value) {
                        // api success
                        if (openedFromModal) openedFromModal.setVisible(false);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        else if (link) {
            updateProductLink(productId, {
                ...payload,
                id: link.id
            })
                .then((value) => {
                    if (value) {
                        // api success
                        if (openedFromModal) openedFromModal.setVisible(false);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };
    return (
        <Formik initialValues={setInitialValues()} validate={validate} onSubmit={submit}>
            {({ values, errors }) => {
                return (
                    <Form>
                        <Container>
                            <FieldLabel>{localizations.links.form.title}</FieldLabel>
                            <FieldContainer>
                                <FormTextInput name="title" placeHolder={localizations.links.form.title} />
                            </FieldContainer>
                            <FieldLabel>{localizations.links.form.url}</FieldLabel>
                            <FieldContainer>
                                <FormTextInput name="url" placeHolder={localizations.links.form.url} />
                            </FieldContainer>
                        </Container>
                        {openedFromModal && (
                            <FormFooter>
                                <Button minWidth="55px" buttonType="filled" type="submit">
                                    {submitLoading ? (
                                        <Loader width="20px" marginTop="0px" showText={false} />
                                    ) : (
                                        <span>{mode === formMode.NEW ? localizations.links.modal.add_btn : localizations.links.modal.edit_btn}</span>
                                    )}
                                </Button>
                            </FormFooter>
                        )}
                    </Form>
                );
            }}
        </Formik>
    );
};
const FieldContainer = styled.div`
    margin-bottom: 12px;
`;

const Container = styled(ModalFormContainer)``;

const FormFooter = styled(ModalFooter)`
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    right: 0;
    background: white;
    justify-content: flex-end;
`;
const mapStateToProps = (state: RootState) => ({
    localizations: localizationSelectors.products(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    createProductLink: (productId: string, link: link) => dispatch.products.createProductLink({ productId, link }),
    updateProductLink: (productId: string, link: link) => dispatch.products.updateProductLink({ productId, link })
});

export default connect(mapStateToProps, mapDispatchToProps)(LinkFormConnected);
